import { createContext, useContext } from "react";
import { ActivityType, User } from "../types/types";

export const AuthContext = createContext<
  {
    user: User | undefined,
    setUser: (user: User | undefined) => void,
    isLoading: boolean,
    activityTypes: ActivityType[] | undefined;
    updateContext: () => void,
  }
>({
  user: undefined,
  setUser: (user: User | undefined) => { },
  isLoading: false,
  activityTypes: undefined,
  updateContext: () => { },
});

export const useAuthContext = () => useContext(AuthContext);